<template>
  <div class="page-about-wrapper">
    <section class="section-banner">
      <fixed-height-img :img-src="bannerImgSrc">
        <template v-slot:content>
          <div class="content-outer-container">
            <div class="text-title-md">{{ $t('about.banner.sloganPart1') }}</div>
            <div class="text-subtitle-xl text-subtitle-sloganPart2">
              {{ $t('about.banner.sloganPart2') }}
            </div>
          </div>
        </template>
      </fixed-height-img>
    </section>
    <section class="section-block section-leading-content-wrapper">
      <div class="content-container">
        <div class="text-content-desc-sm text-content-desc-leading-content">
          {{ $t('about.leadingContent.item1') }}
        </div>
      </div>
    </section>
    <section class="section-block">
      <div class="section-wrapper">
        <about-journey></about-journey>
      </div>
    </section>
    <section class="section-block section-rewards-wrapper">
      <div class="section-wrapper">
        <rewards-and-certification></rewards-and-certification>
      </div>
    </section>
    <section class="section-block">
      <div class="section-wrapper">
        <contact-info></contact-info>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import languageList from '../configs/languageList';
import ContactInfo from '../components/about/ContactInfo.vue';
import FixedHeightImg from '../components/shared/FixedHeightImg.vue';
import AboutJourney from '../components/about/AboutJourney.vue';
import RewardsAndCertification from '../components/about/RewardsAndCertification.vue';

export default {
  name: 'about',
  components: {
    ContactInfo,
    FixedHeightImg,
    AboutJourney,
    RewardsAndCertification,
  },
  headMetaInfo() {
    return {
      title: this.$t('headMetaInfo.about.title'),
      titleTemplate: `%s - ${this.$t('headMetaInfo.default.titleTemplate')}`,
      meta: [
        { name: 'description', content: this.$t('about.leadingContent.item1') },
        { property: 'og:title', content: this.$t('headMetaInfo.about.title') },
        { property: 'og:description', content: this.$t('about.leadingContent.item1') },
      ],
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      link: (() => {
        // Ugly code, could be better!
        // { rel: 'canonical', href: `${window.location.origin}/` }
        // { rel: 'alternate', hreflang: this.$i18n.locale, href: `${window.location.origin}/` }
        const linkArray = [];
        if (process.env.NODE_ENV === 'prerender') {
          const baseUrl = process.env.BASE_URL.startsWith('http') ? process.env.BASE_URL : 'https://www.lollipop.camera';
          linkArray.push({ rel: 'canonical', href: `${baseUrl}/about` });
          languageList.forEach((lang) => {
            linkArray.push({ rel: 'alternate', hreflang: lang, href: `${baseUrl}/${lang}/about` });
          });
        }
        return linkArray;
      })(),
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
    bannerImgSrc() {
      return this.isMobile ? '/media/img/about/banner_m.jpg' : '/media/img/about/banner.jpg';
    },
  },
  created() {
    this.scrollToTop();
  },
  beforeMount() {
    window.gtag('event', 'conversion', { send_to: 'AW-851342225/sD5_CIK2rqMBEJHn-ZUD' });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="sass" scoped>
.content-outer-container
  width: 70vw
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  .text-subtitle-sloganPart2
    margin-top: 8px

.page-about-wrapper
  overflow-x: hidden
  background-color: $background-primary
  .section-block
    display: flex
    justify-content: center
    width: 100%
    padding: 56px 0px
    .section-wrapper
      padding: 0 60px
    &.section-leading-content-wrapper
      width: 100vw
      display: flex
      justify-content: center
      padding: 72px 0
      background-color: #F8F8F8
      .content-container
        width: 70vw
        text-align: left
        .text-content-desc-leading-content
          line-height: 1.5
    &.section-rewards-wrapper
      background-color: #F8F8F8

@media screen and (min-width: 1600px)
  .page-about-wrapper
    .section-block
      padding: 80px 0px
      &.section-leading-content-wrapper
        .content-container
          width: 60vw

/** Mobile */
@media only screen and (max-width: 768px)
  .page-about-wrapper
    .section-block
      padding: 48px 0px
      .section-wrapper
        padding: 0 48px

@media only screen and (max-width: 360px)
  .page-about-wrapper
    .section-block
      padding: 36px 0px
</style>
